import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MapDialogComponent } from 'src/app/shared/components/map-dialog/map-dialog.component';

@Component({
  selector: 'app-event-banner-details',
  templateUrl: './event-banner-details.component.html',
  styleUrls: ['./event-banner-details.component.scss']
})
export class EventBannerDetailsComponent implements OnInit {
  @Input() productName;
  @Input() bussinessName;
  @Input() location;
  @Input() startDay;
  @Input() endDay;

  constructor(
    private Dialog: MatDialog,
  ) { }

  ngOnInit(): void {
  }
  openMap() {
    const dialogRef = this.Dialog.open(MapDialogComponent, {
      height: "400px",
      width: "500px",
      data: {
        coordinates: this.location
      }
    });
  }
}
